export function gotoElement(elementName){
    let element = document.getElementById(elementName);    
    element.scrollIntoView();
}


// WEBPACK FOOTER //
// ./src/Helpers/NavigationHelper.js